
// Action Types for JSBridge navigation
export const ACTION_TYPES = {
    NAVIGATION: 'NAVIGATION',
    ROUTE: 'ROUTE',
    DEEPLINK: 'DEEPLINK',
    PO_PENDING_ACCEPTANCE_DETAIL: 'PO_PENDING_ACCEPTANCE_DETAIL',
    DD_PO_LIST_PAGE: 'DD_PO_LIST_PAGE',
    ALL_PO_NO_GRN_YET_PAGE: 'ALL_PO_NO_GRN_YET_PAGE',
    GRN_PENDING_CONFIRMATION_PAGE: 'GRN_PENDING_CONFIRMATION_PAGE',
    SELLER_PO_LIST: 'SELLER_PO_LIST',
    SELLER_DD_PO_LIST: 'SELLER_DD_PO_LIST',
    SELLER_GRN_PENDING: 'SELLER_GRN_PENDING',
    SELLER_PO_DETAIL: 'SELLER_PO_DETAIL',
    SELLER_DD_PO_DETAIL: 'SELLER_DD_PO_DETAIL',
    SELLER_GRN_DETAIL: 'SELLER_GRN_DETAIL',
};
